import { Box, Divider, Stack } from "@mui/material";
import type { QuestionnaireGroupDto, QuestionnaireQuestionDto } from "Infrastructure/ApiZfp/Schema";
import { useResponsive } from "Infrastructure/Hooks/useResponsive";
import { Spacing, TABLET_MAX_WIDTH } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { ReactNode } from "react";
import { QuestionnaireBlocks } from "./QuestionnaireBlocks";
import { QuestionnaireInitBlock } from "./QuestionnaireInitBlock";
import { QuestionnaireOrganizedBy } from "./QuestionnaireOrganizedBy";
import { QuestionnaireSectionHeader } from "./QuestionnaireSectionHeader";
import { QuestionnaireSidebar } from "./QuestionnaireSidebar";
import type { InvestmentPlan } from "./types";
import { useRuleEngine } from "./useRuleEngine";

type Props = {
  questions: QuestionnaireQuestionDto[];
  currentGroup: QuestionnaireGroupDto;
  investmentPlans: InvestmentPlan[];
  shouldShowInitBlock: boolean;
  collectedData: Record<string, any>;
  footer: ReactNode;
  stepIndex: number;
};

export const QuestionnaireStep = ({
  currentGroup,
  questions,
  investmentPlans,
  shouldShowInitBlock,
  collectedData,
  footer,
  stepIndex,
}: Props) => {
  const initQuestions = questions.filter((q) => q.questionnaireGroupBlockID === null && q.parentQuestionID === null);
  const ruleState = useRuleEngine(questions, collectedData);
  const isTablet = useResponsive(TABLET_MAX_WIDTH);
  const { t } = useResource();

  return (
    <Stack direction={isTablet ? "column" : "row"} divider={<Divider orientation="vertical" flexItem />}>
      <Stack pr={Spacing.XL} flex={1} minWidth={0}>
        <Stack spacing={Spacing.XXL}>
          {shouldShowInitBlock && <QuestionnaireInitBlock questions={initQuestions} ruleState={ruleState} />}

          <QuestionnaireBlocks group={currentGroup} questions={questions} investmentPlans={investmentPlans} ruleState={ruleState} />

          {shouldShowInitBlock && (
            <Box>
              <QuestionnaireSectionHeader title={t(Resources.Questionnaire.OrganizedBy)} />
              <Box pt={Spacing.XL}>
                <QuestionnaireOrganizedBy />
              </Box>
            </Box>
          )}
        </Stack>
        {footer}
      </Stack>

      <QuestionnaireSidebar stepIndex={stepIndex} />
    </Stack>
  );
};
